import React from 'react'
import { Link } from 'react-router-dom';

function Home() {
    return (
        <>
            <div className="lg:py-10 lg:px-10 py-0 px-6">
                <div className="flex flex-col items-center">

                    <div className="lg:max-w-6xl px-4 py-6 justify-center items-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2 justify-center items-center">
                            <div tabindex="0" style={{ transform: 'none' }}>
                                <div className="group flex flex-col h-[26rem] justify-center  rounded-xl transition" >
                                    <div className="relative overflow-hidden">
                                        <div style={{ opacity: '1', transform: 'none' }}>
                                            <div className="p-6 flex-grow">
                                                <h2 className='text-4xl font-semibold'>SEO Pages</h2>
                                                <ul className="font-sans list-none space-y-3 text-gray-700 my-4">
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-classes"> CMA Classes Page</Link>
                                                    </li>
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-fees">CMA Fees Page</Link>
                                                    </li>
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-exam"> CMA Exams Page</Link>
                                                    </li>
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-salary"> CMA Salary Page</Link>
                                                    </li>
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-study-material"> CMA Study Material Page</Link>
                                                    </li>
                                                    <li className="text-2xl font-semibold">
                                                        <Link to="/cma-review">CMA Review Page</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Home;
